import type {SVGProps} from 'react'
const SvgHide = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 640 512" {...props}>
    <path
      d="M35.1 256.6C92.5 385.5 198.6 472 320 472s227.5-86.6 284.9-215.5C547.5 127.6 441.4 41.1 320 41.1S92.5 127.7 35.1 256.6"
      style={{
        fill: '#fff',
      }}
    />
    <circle
      cx={320}
      cy={254.9}
      r={125.3}
      style={{
        fill: 'sienna',
      }}
    />
    <path
      d="M636.1 497.7c4.3 2.8 4.9 7.8 2.2 10.4-2.8 4.3-7.8 4.9-11.3 2.2L3 14.3C-.4 11.5-1 6.5 1.7 3 4.5-.4 9.5-1 13 1.7zm-30.6-229.4c-9.6 23-26 52.8-49 82.7l-13.4-9.9c22.9-28.7 38.6-58 47.7-78.9 1.6-4 1.6-8.4 0-12.4-14.1-34.7-44.2-83.8-89.1-125.5-45.1-41.9-106.1-77.2-182.6-77.2-41.2 0-78.8 11.6-111.7 28.3l-13.7-10.8C229.9 45 272.2 31.1 320 31.1c80.8 0 145.5 37.7 192.6 81.5 46.8 43.4 78.1 94.5 92.9 131.1 3.3 7.9 3.3 16.7 0 24.6m-522-108.2L96 170.9c-22 28.7-37.7 57.1-46.8 78.9-1.6 4-1.6 8.4 0 12.4 14.1 33.8 44.1 82.9 89.1 125.5C183.4 429.6 244.4 464 320 464c42.1 0 79.7-10.7 112.6-27.4l13.7 10.9c-36.2 19.6-78.5 32.5-127.2 32.5-79.9 0-144.6-36.8-191.7-80.6-46.8-44.3-78.1-95.4-92.9-131.1-3.3-7.9-3.3-16.7 0-24.6 9.6-23 26-52.8 49-83.6M208 259.4l17.5 13.7c8.1 44 47.3 78.9 94.5 78.9 1.8 0 3.5-.9 5.2-.1l17.5 13.8c-7.3 1.5-14.9 2.3-22.7 2.3-60.7 0-110.2-48.3-112-108.6m111.1-116.3c61.6 0 111.1 49.2 112.8 109.5l-17.4-13.8c-8.1-44.8-47.3-79.7-95.4-79.7-.9 0-2.6.9-4.3 1l-17.5-13.8c7.3-1.5 14.9-3.2 21.8-3.2"
      style={{
        fill: '#333',
      }}
    />
  </svg>
)
export default SvgHide
